export const USER_GUIDE_I18N = {
  addClient: {
    title: 'How to add a client?',
    text1: 'First let\'s add a client to Ledgersync <br /> Navigate to Clients page',
    text2: 'Click on the \'Add Client\' button to add a client',
  },
  workWithClient: {
    title: 'How to work with client?',
    text1: 'Select client from the list',
    text2: 'Click to add a bank connection',
    text3: 'Search for the client\'s bank. LedgerSync picks the best way to connect it.',
  },
} as const;
